import React from "react"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import Button from "aldoo-ra/Button"
import Localization from "aldoo-ra/Localization"

export default function ShoppingCartHeaderContent({ store }) {
  const texts = TextBundle({ id: "aldoo-store" })
  const { t } = Localization()
  const { cart } = store

  return (
    <>
      <span className="mr-5 px-4 py-3 text-text_secondary rounded-full bg-canvas border border-bordered">
        {t(texts?.items, { count: cart.length })}
      </span>
      <Button
        variant="secondary"
        className="flex items-center gap-2 px-2 mr-[50px]"
        onClick={() => {
          store.emptyCart()
        }}
      >
        {texts?.empty_cart}
      </Button>
    </>
  )
}
